import { Button, Modal } from 'antd';
import React from 'react';

import { ConfettiAnimation } from '../ConfettiAnimation';
import { TOTAL_ROUNDS } from './constants';

export const RoundResultModal = ({
    visible,
    correct,
    round,
    totalRounds = TOTAL_ROUNDS,
    wrongVerdict,
    onNext,
    onShowResult,
    children,
}) => {
    const isLastRound = round >= totalRounds;
    const verdictText = correct ? 'Správně!' : wrongVerdict || 'Špatně :(';

    return (
        <Modal
            open={visible}
            footer={null}
            centered
            destroyOnClose
            closable={false}
            maskClosable={false}
            keyboard={false}
            bodyStyle={{
                ...(!correct && { backgroundColor: '#fff2f0' }),
            }}
        >
            {correct && <ConfettiAnimation />}
            <div className="result-modal-container">
                <div className="result-modal-container-item">
                    <h2>
                        Kolo: {round}/{totalRounds}
                    </h2>
                    <h3>{verdictText}</h3>
                </div>
                <div className="result-modal-container-more-info">{children}</div>
                <div className="result-modal-button">
                    {isLastRound ? (
                        <Button size="large" type="primary" onClick={onShowResult}>
                            Vyhodnotit hru
                        </Button>
                    ) : (
                        <Button size="large" type="primary" onClick={onNext}>
                            Další kolo
                        </Button>
                    )}
                </div>
            </div>
        </Modal>
    );
};
